<template>
  <div id="info-overlay">
    <b-row class="p-5" id="info-row">
      <b-col>
        <b-row class="text-center">
          <b-col>
            <h1>Szanowny Użytkowniku, w systemie PIT nie jesteś przedstawicielem żadnej organizacji.</h1>
          </b-col>
        </b-row>
        <hr/>
        <b-row class="text-center pt-1 pb-5">
          <b-col>
            <p>
              Przedstawicieli organizacji dodaje administrator organizacji na <a class="link-underlined" href="https://pue.uke.gov.pl/" target="_blank">PUE UKE</a>, zgodnie z <a class="link-underlined" href="https://pit.uke.gov.pl/pl-pl/pomoc/?categoryId=13350" target="_blank">instrukcją</a>. W przypadku braku konta organizacji na <a class="link-underlined" href="https://pue.uke.gov.pl/" target="_blank">PUE UKE</a> należy je założyć zgodnie z <a class="link-underlined" href="https://pit.uke.gov.pl/pl-pl/pomoc/?categoryId=13350" target="_blank">instrukcją</a>. Problemy dotyczące zakładania konta i/lub dodania przedstawiciela prosimy kierować na adres <a class="link-underlined" href="mailto:pue@uke.gov.pl">pue@uke.gov.pl</a>.
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'no-organization-overlay'
}
</script>

<style scoped>
</style>
